import { render, staticRenderFns } from "./ModalImagesLots.vue?vue&type=template&id=35d89d35&scoped=true&lang=pug&"
import script from "./ModalImagesLots.vue?vue&type=script&lang=js&"
export * from "./ModalImagesLots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d89d35",
  null
  
)

export default component.exports